// assets/category-circles.js

(function() {
  function initCategoryCircles() {
    const container = document.querySelector('.category-circles-container');
    if (!container) return;

    const row = container.querySelector('#categoryCirclesRow');
    const circles = container.querySelectorAll('.category-circle');
    
    if (!row || !circles.length) return;

    function isMobile() {
      return window.innerWidth <= 749;
    }

    function setupMobile() {
      if (!isMobile()) return;
      
      bindMobileEvents();
    }

    function bindMobileEvents() {
      let touchStartX = 0;
      let touchEndX = 0;
      const minSwipeDistance = 30;

      // Touch events for smooth swiping (like Instagram stories)
      row.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });

      row.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].clientX;
        const swipeDistance = touchStartX - touchEndX;
        
        if (Math.abs(swipeDistance) > minSwipeDistance) {
          const currentScroll = row.scrollLeft;
          const circleWidth = circles[0].offsetWidth;
          const gap = 12.8; // 0.8rem gap in mobile
          const scrollAmount = (circleWidth + gap) * 2.5; // Scroll by 2.5 circles for smooth progression
          
          if (swipeDistance > 0) {
            // Swiped left - scroll right
            row.scrollTo({
              left: currentScroll + scrollAmount,
              behavior: 'smooth'
            });
          } else {
            // Swiped right - scroll left
            row.scrollTo({
              left: currentScroll - scrollAmount,
              behavior: 'smooth'
            });
          }
        }
      }, { passive: true });

      // Also enable natural scrolling
      row.addEventListener('scroll', () => {
        // Just let it scroll naturally, no need to snap to specific positions
      }, { passive: true });
    }

    // Initialize
    setupMobile();

    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(setupMobile, 250);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCategoryCircles);
  } else {
    initCategoryCircles();
  }

  // Re-initialize when section is loaded in theme editor
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.category-circles-section')) {
      setTimeout(initCategoryCircles, 100);
    }
  });
})();